import * as components from 'components';

export const comps = components;

export default components;
